import { useRef } from 'react'
import { StyledBody, StyledRoot } from '../Cortext/Cortext'
import SettingsPortal from '../../components/SettingsPortal'
import { StyledSettings } from '../Cortext/Settings/SettingsStyles.css'
import ImagesChatWindow from '../../components/ImagesChatWindow'
import ChatInput from '../../components/ChatInput'
import { useTensorAlchemy } from './useTensorAlchemy'
import { FormikProvider } from 'formik'

import FormikTextField from 'components/TextFieldFormik'
import TextareaFormik from 'components/TextareaFormik'
import Slider from 'components/Slider'
import SubnetDescription from '../../components/SubnetDescription'
import ImagesHistoryList from '../../components/History/ImagesHistoryList'
import Examples from '../../components/Examples'
import { imageExamples } from '../Cortext/types'

const TensorAlchemy = () => {
    const tensorRef = useRef(null)

    const { formik, responseLoading, image, displayPrompt, handleStopRequest } = useTensorAlchemy()

    return (
        <FormikProvider value={formik}>
            <StyledRoot ref={tensorRef}>
                <ImagesHistoryList />
                <StyledBody>
                    <ImagesChatWindow
                        loading={responseLoading}
                        images={[image?.url || '']}
                        displayPrompt={displayPrompt}
                    />

                    <ChatInput
                        formik={formik}
                        fieldName='prompt'
                        stopRequest={{ requestLoading: responseLoading, handleStopRequest }}
                    />
                </StyledBody>
            </StyledRoot>

            <SettingsPortal portalRef={tensorRef}>
                <StyledSettings>
                    <SubnetDescription
                        noText
                        title={'26. Tensor Alchemy'}
                        description={
                            'Human Scoring and Decentralized Image Generation on Bittensor'
                        }
                        docUrl={`${import.meta.env.REACT_APP_SUBNET_DOCS_URL}/tensor-alchemy`}
                    />

                    <Examples
                        disabled={responseLoading}
                        formik={formik}
                        chatInputName={'prompt'}
                        examples={imageExamples}
                    />

                    <FormikTextField name='height' placeholder={'height'} label={'Height'} />
                    <FormikTextField name='width' placeholder={'width'} label={'Width'} />
                    <FormikTextField
                        name='guidance_scale'
                        placeholder={'guidance_scale'}
                        label={'Guidance scale'}
                    />
                    <Slider
                        name='steps'
                        label='Steps'
                        min={1}
                        max={50}
                        step={1}
                        value={formik.values.steps}
                        onChange={value => formik.setFieldValue('steps', value)}
                    />
                    <FormikTextField name='seed' placeholder={'seed'} label={'Seed'} />

                    <TextareaFormik
                        label={'Negative prompt'}
                        value={formik.values.negative_prompt}
                        fieldName={'negative_prompt'}
                    />
                </StyledSettings>
            </SettingsPortal>
        </FormikProvider>
    )
}

export default TensorAlchemy
